import type { components } from '@connected/api-client/api.generated';

import { createContext, use } from 'react';

export type DistributionBoard = components['schemas']['ListElectricalProjectDistributionBoardQueryResultBoard'];

export type DistributionBoardContext = {
    distributionBoards: DistributionBoard[];
    distributionBoard: DistributionBoard | null;
    optimisticUpdate: (distributionBoard: DistributionBoard) => void;
};

export const DistributionBoardContext = createContext<DistributionBoardContext | null>(null);

export function useDistributionBoards() {
    const context = use(DistributionBoardContext);
    if (!context) {
        throw new Error('useDistributionBoards must be used within a DistributionBoardProvider');
    }
    return context;
}
